import script from "./UserRightBar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRightBar.vue?vue&type=script&setup=true&lang=js"

import "./UserRightBar.vue?vue&type=style&index=0&id=1be7e6f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be7e6f0"]])

export default __exports__